<template>
    <div class="mb-6">

        <!-- <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs> -->

        <v-row>
            <v-col cols="12" md="5">
                <v-form @submit.prevent="register" ref="refRegister" lazy-validation>
                    <v-card :loading="loading" :disabled="dataBanner.length==5">
                        <v-card-title>
                            Crear nuevo banner
                            <small v-if="dataBanner.length==5">Solo se admite 5 Imágenes</small>
                        </v-card-title>
                        <v-card-text>
                            <!-- banner -->
                            <div class="mb-4">
                                <input type="file"
                                    accept="image/png,image/jpeg,image/jpg"
                                    ref="fileImg"
                                    class="d-none"
                                    @change="previewImage"
                                >
                                <v-btn @click="addNewImage" color="primary" class="mb-3" :disabled="loading">
                                    Añadir imagen <v-icon>mdi-image-plus</v-icon>
                                </v-btn>
                                <v-img
                                    :src="(previewImg!='')?previewImg:'/images/overlay-img.png'"
                                    :lazy-src="(previewImg!='')?previewImg:'/images/overlay-img.png'"
                                    :aspect-ratio="4/2"
                                    color="grey lighten-2"
                                    class="text-right"
                                >
                                    <v-btn v-if="previewImg!=''" @click="removeImage()" fab x-small dark color="red darken-3">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-img>
                            </div>
                            <!-- banner END -->
                            <v-checkbox
                                v-model="data.is_btn"
                                label="Añadir botón"
                                :value="false"
                                :disabled="loading"
                            ></v-checkbox>
                            <v-text-field
                                label="Texto del botón"
                                v-model="data.textBtn"
                                outlined
                                dense
                                :disabled="loading"
                                v-if="data.is_btn"
                            ></v-text-field>
                            <v-radio-group
                                v-model="data.type"
                                column
                                :disabled="loading"
                                v-if="data.is_btn"
                            >
                                <v-radio
                                    label="A una categoría"
                                    value="category"
                                ></v-radio>
                                <v-radio
                                    label="Link externo"
                                    value="link"
                                ></v-radio>
                            </v-radio-group>
                            <v-text-field
                                label="Link externo"
                                v-model="data.link"
                                outlined
                                dense
                                type="url"
                                :disabled="loading"
                                v-if="data.type=='link'"
                            ></v-text-field>
                            <v-select
                                :items="itemsCategories"
                                v-model="data.category"
                                item-text="name"
                                item-value="slug"
                                label="Categoría"
                                dense
                                outlined
                                :disabled="loading"
                                v-if="data.type=='category'"
                            ></v-select>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                outlined
                                color="error"
                                :disabled="loading"
                                @click="clearData"
                            >Cancelar</v-btn>
                            <v-btn
                                type="submit"
                                color="primary"
                                :loading="loading"
                            >Registrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
            <v-col cols="12" md="7">
                <v-card>
                    <v-card-title class="blue-grey darken-4 white--text">
                        Banners
                    </v-card-title>

                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left text-uppercase">
                                        Banner
                                    </th>
                                    <th class="text-left text-uppercase">
                                        Tipo
                                    </th>
                                    <th class="text-right text-uppercase">
                                        Acciones
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in dataBanner" :key="index">
                                    <td class="py-1">
                                        <v-img
                                            :src="item.banner"
                                            :aspect-ratio="2/1"
                                        ></v-img>
                                    </td>
                                    <td v-if="item.is_btn">{{ (item.type=='category') ? 'Categoría' : 'Link' }}</td>
                                    <td v-else></td>
                                    <td class="text-right">
                                        <div class="d-flex justify-end">
                                            <!-- <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="editUser(item.id)"
                                                    >
                                                        <v-icon color="grey">
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Editar</span>
                                            </v-tooltip> -->

                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="deleteBanner(item.id)"
                                                    >
                                                        <v-icon color="grey">
                                                            mdi-delete
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Eliminar</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </div>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            breadcrumbs: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    href: '/admin/dashboard',
                },
                {
                    text: 'Banners',
                    disabled: true,
                    href: '',
                }
            ],
            loading: false,
            itemsCategories: [],
            // banner
            previewImg: '',
            data: {
                img: null,
                is_btn: false,
                textBtn: '',
                type: '',
                link: '',
                category: '',
            },
            dataBanner: []
        }
    },
    props: ['slug'],
    mounted() {
        this.getCategories();
        this.getMainBanner();
    },
    methods: {
        async getCategories() {
            await axios.post('/admin/list-categories', {})
            .then(response => {
                this.itemsCategories = response.data;
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        // banner
        addNewImage() {
            this.$refs.fileImg.click();
        },
        previewImage (event) {
            const file = event.target.files[0]
            const fileType = file.type
            if (fileType == 'image/jpeg' || fileType == 'image/jpg' || fileType == 'image/png') {
                this.data.img = (file)
                this.previewImg = URL.createObjectURL(file)
            } else {
                this.$notify.warning('Formato no permitido.');
                return
            }
        },
        removeImage() {
            this.previewImg = ''
            this.data.img = null
        },
        // end banner
        clearData() {
            this.data = {
                img: null,
                is_btn: false,
                type: '',
                link: '',
                category: '',
            }
            this.previewImg = ''
        },
        /**
         * lista de banners
         */
        async getMainBanner() {
            this.overlay = true
            this.dataBanner = []
            await axios.get(`/get-banners/${this.slug}`)
            .then((response) => {
                // console.log(response);
                response.data.forEach(element => {
                    let content = JSON.parse(element.content)
                    content.id = element.id
                    this.dataBanner.push(content)
                });
                this.overlay = false
            })
            .catch((error) => {
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },
        /**
         * Register new banner
         */
        async register() {
            if (this.$refs.refRegister.validate()) {
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('img', this.data.img)
                formData.append('is_btn', this.data.is_btn)
                formData.append('text_btn', this.data.textBtn)
                formData.append('type', this.data.type)
                formData.append('link', this.data.link)
                formData.append('category', this.data.category)
                formData.append('slug', this.slug)
                await axios.post('/admin/new-banner', formData)
                .then(response => {
                    // console.log(response);
                    if (response.data == 'ok') {
                        this.$notify.success('Banner registrado correctamente.');
                        this.getMainBanner()
                        this.clearData()
                    }
                    this.loading = false
                })
                .catch(error => {
                    // console.log(error);
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
            }
        },

        /**
         * Delete
         */
        deleteBanner (id) {
            this.$confirm(
                'Se eliminará permanentemente del sistema',
                '¿Eliminar banner?',
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
            }).then(res => {
                if (res) {
                    axios.delete(`/admin/del-banner/${id}`)
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$notify.success('Banner registrado correctamente.');
                            this.getMainBanner()
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                    })
                }
            });
        },
    },
}
</script>
